import React from 'react';
import {useIntl} from 'react-intl';

export const TaskModalEstimatePlaceholder = () => {
	const intl = useIntl();

	return (
		<div className={'header-tile header-tile-forecast'}>
			<div className="tile-wrapper">
				<div className="tile-container">
					<div className="tile-label">{intl.formatMessage({id: 'common.estimate'})}</div>
					<div className="text-container">
						<div className="number-text">-</div>
					</div>
				</div>
			</div>
		</div>
	);
};
